import { NgModule } from '@angular/core';
import { VimeoService } from './vimeo.service';
import { VimeoByUriPipe } from './vimeoByUri.pipe';
import { VimeoThumbnailsByIdPipe } from './vimeo-thumbnails-by-id.pipe';

@NgModule({
  imports: [],
  declarations: [VimeoByUriPipe, VimeoThumbnailsByIdPipe],
  exports: [VimeoByUriPipe, VimeoThumbnailsByIdPipe],
  providers: [VimeoService],
})
export class VimeoModule {}
